"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Summary = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _AdditionalInfo = require("../AdditionalInfo");
var _CashbackAndBonus = require("../CashbackAndBonus");
var _Continue = require("../Continue");
var _StickyPanel = require("../StickyPanel");
var _TermsAndConditionsConsent = require("../TermsAndConditionsConsent");
var _styles = require("./styles");
var _useSummary = require("./useSummary");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const Summary = ({
  continueButtonTooltip,
  isOnlinePaymentMethod,
  isOrderReviewSkipped,
  selectedStep,
  setCurrentStep,
  setIsRegistrationVisible,
  shoppingContext
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    culture,
    financialSet
  } = (0, _culture.useCulture)();
  const {
    additionalInfoProps,
    fees,
    handleRemoveVoucher,
    orderItemsQuantity,
    termsAndConditionsProps,
    vouchers
  } = (0, _useSummary.useSummary)({
    selectedStep,
    shoppingContext
  });
  const {
    isAnonymous,
    shoppingBag,
    showBp
  } = shoppingContext;
  const isLastStep = selectedStep === _types.ShoppingStep.Checkout;
  const remainingPrepayment = (0, _culture.formatCurrency)(shoppingBag.balanceAfter.prepayment, culture, financialSet);
  const ownerState = {
    isLastStep
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ...getTestIdProps(_types.TestId.Summary),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SummaryTitle, {
        variant: "h6",
        ...getTestIdProps(_types.TestId.Title),
        children: formatMessage('orderSummary')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Subtotal),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
          children: [formatMessage('subtotal'), " (", orderItemsQuantity, " ", formatMessage('items'), ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: shoppingBag.totalPriceWithoutFees
        })]
      }), fees.map(({
        name,
        value
      }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Fee),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: formatMessage(name)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: value
        })]
      }, name)), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Delivery),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
            children: [formatMessage(shoppingBag.isHomeDelivery ? 'homeDelivery' : 'pickUpPointDelivery'), shoppingBag.deliveryDate ? ` (${shoppingBag.deliveryDate})` : null]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: shoppingBag.deliveryFee
        })]
      }), shoppingBag.discounts.map(({
        amount,
        description
      }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Discount),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: description === '' ? formatMessage('discount') : description
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: amount
        })]
      }, `${description}-${amount}`)), shoppingBag.walletPayment ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.WalletPayment),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: formatMessage('paidWithOriflameWallet')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: shoppingBag.walletPayment
        })]
      }) : null, vouchers.map(({
        code,
        name,
        value
      }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Voucher),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.VoucherItem, {
          children: [name, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TrashIcon, {
            onClick: async () => handleRemoveVoucher(code)
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: value
        })]
      }, name)), shoppingBag.prepaid || shoppingBag.balanceAfter.prepayment ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SummaryLine, {
        ...getTestIdProps(_types.TestId.Prepaid),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: formatMessage('prepaidRemainingX', {
            0: remainingPrepayment
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: shoppingBag.prepaid
        })]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ToPayLine, {
        ...getTestIdProps(_types.TestId.ToPay),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          children: formatMessage('toPay')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          children: shoppingBag.debt
        })]
      }), !isAnonymous && (shoppingBag.cashbackEarned || showBp) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CashbackAndBonus.CashbackAndBonus, {
        cashbackEarned: shoppingBag.cashbackEarned,
        showBp: showBp,
        totalBp: shoppingBag.totalBp
      }) : null, isLastStep ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsAndConditionsConsent.TermsAndConditionsConsent, {
        ...termsAndConditionsProps
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContinueWrapper, {
        ownerState: ownerState,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Continue.Continue, {
          continueButtonTooltip: continueButtonTooltip,
          isAnonymous: isAnonymous,
          isOnlinePaymentMethod: isOnlinePaymentMethod,
          isOrderReviewSkipped: isOrderReviewSkipped,
          selectedStep: selectedStep,
          setIsRegistrationVisible: setIsRegistrationVisible,
          setCurrentStep: setCurrentStep
        })
      })]
    }), isLastStep ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_StickyPanel.StickyPanel, {
      isAnonymous: isAnonymous,
      continueButtonTooltip: continueButtonTooltip,
      toPay: shoppingBag.debt,
      selectedStep: selectedStep,
      setIsRegistrationVisible: setIsRegistrationVisible,
      setCurrentStep: setCurrentStep
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdditionalInfo.AdditionalInfo, {
      ...additionalInfoProps
    })]
  });
};
exports.Summary = Summary;